// socket.js
import { io } from "socket.io-client";
import consts from "./consts";

let socket;
if (consts?.type == "Production") {
  socket = io(`${consts?.socketUrl}`, { path: "/socket" }); // for Live
} else {
  socket = io(`${consts?.socketUrl}`); // for local
};

export default socket;